import { render } from "./NavbarMain.vue?vue&type=template&id=4dc8231a&scoped=true"
import script from "./NavbarMain.vue?vue&type=script&lang=js"
export * from "./NavbarMain.vue?vue&type=script&lang=js"

import "./NavbarMain.vue?vue&type=style&index=0&id=4dc8231a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc8231a"]])

export default __exports__